export default __webpack_public_path__ + "static/media/DIABETES-MELLITUS-TYPE-2.a976f73d.png";